import * as React from 'react';
import UserInfo from './UserInfo';
import style from 'web/screen/HomePage/UserInfo/UserInfo.module.scss';
import { Button, Typography } from 'antd';
import UserInfoEditDialog from 'web/screen/HomePage/UserInfoEditDialog/UserInfoEditDialog';
import UserInfoEditDialogView from 'web/screen/HomePage/UserInfoEditDialog/UserInfoEditDialogView';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import Link from 'web/components/Link';
import EditIcon from 'common/icons/edit_v2.svg';

interface UserDataProps {
    model: UserInfo;
}

const UserData: React.FC<UserDataProps> = observer(({ model }) => {
    const { t } = useTranslation(['homePage', 'common']);
    return (
        <>
            <div className={style.titleBox}>
                <Typography.Title level={3}>{model.fullName}</Typography.Title>

                <div className={style.actions}>
                    <>
                        <img
                            src={EditIcon}
                            alt='edit'
                            className={style.dropdownIcon}
                        />

                        <Link onClick={model.showEditUser} style={style.edit}>
                            {t('common:edit')}
                        </Link>
                    </>
                </div>
            </div>
            <div className={style.infoBox}>
                <div className={style.list}>
                    <span className={style.listItem}>
                        {t('homePage:mobile')}
                    </span>
                    <span className={style.listItem}>
                        {model.dto.phoneNumber ?? '-'}
                    </span>
                </div>
                <div className={style.list}>
                    <span className={style.listItem}>
                        {t('homePage:email')}
                    </span>
                    <span className={style.listItem}>{model.dto.email}</span>
                </div>
            </div>
            {model.parent.dialog instanceof UserInfoEditDialog && (
                <UserInfoEditDialogView dialog={model.parent.dialog} />
            )}
        </>
    );
});

export default UserData;
